<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pb-2 mt-1">
                <v-col sm="4" md="4" class="py-0" justify="center" align="center">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('pendings.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="8" align="end" class="py-0">
                    <btn-secondary :label="$t('pendings.annex_masive')" :icon="'assignment'" @click="to_massive_annex_24" v-permission="'i_multiple.create'"></btn-secondary>
                    <btn-secondary :label="$t('pendings.massive_upload')" :icon="'cloud_upload'" @click="to_upload_multiple" v-permission="'i_multiple.create'"></btn-secondary>
                    <btn-primary :label="$t('pendings.new')" :icon="'add'" @click="to_create_national" v-permission:all="'appointment.create|i_pending.create'"></btn-primary>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :pagination="[10, 20, 50, 100]" :props="{headers:headers, items: props.items, search:props.search}" :itemsLength="props.meta.total" :options.sync="pagination.pendings" @update:options="(options) => onOptionsChange(options)" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>        
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>

import { HttpAppointmentRepository } from '../../infrastructure/appointment_repository';
import { appointmentIndexUseCase } from '../../application/use_cases/appointment_index_use_case';

export default {
    computed: {
        headers(){
            //adding column operation in Spanish
            if(this.$store.state.language == 'es') return [
                { text: this.$t('pendings.id'), value: 'idIndex', class: 'text-uppercase' },
                { text: this.$t('pendings.client'), value: 'client.name', class: 'text-uppercase' },
                { text: this.$t('pendings.date'), value: 'arrival_date', class: 'text-uppercase' },
                { text: this.$t('pendings.movement_type'), value: this.$store.state.language == 'es' ? 'operation.description_es' : 'operation.description_en', class: 'text-uppercase' },
                { text: this.$t('pendings.container'), value: 'container_number', class: 'text-uppercase' },
                { text: this.$t('pendings.description'), value: 'description', class: 'text-uppercase' },
                { text: this.$t('pendings.comments'), value: 'commentary', class: 'text-uppercase' },
                { text: this.$t('pendings.user'), value: 'user.name', class: 'text-uppercase' },
                { text: this.$t('pendings.actions'), value: 'actions', align: "center", class: 'text-uppercase' },
            ]
            //adding columnm operation in English
            else return [
                { text: this.$t('pendings.id'), value: 'idIndex', class: 'text-uppercase' },
                { text: this.$t('pendings.client'), value: 'client.name', class: 'text-uppercase' },
                { text: this.$t('pendings.date'), value: 'arrival_date', class: 'text-uppercase' },
                { text: this.$t('pendings.movement_type'), value: 'operation.description1', class: 'text-uppercase' },
                { text: this.$t('pendings.container'), value: 'container_number', class: 'text-uppercase' },
                { text: this.$t('pendings.description'), value: 'description', class: 'text-uppercase' },
                { text: this.$t('pendings.comments'), value: 'commentary', class: 'text-uppercase' },
                { text: this.$t('pendings.user'), value: 'user.name', class: 'text-uppercase' },
                { text: this.$t('pendings.actions'), value: 'actions', align: "center", class: 'text-uppercase' },
            ]
        } 
    },
    data(){
        return {
            m_type: this.$route.params.m_type, // income || outcome
            items: {
                clients: []
            },
            actions_outcome: [
                {
                    name: this.$t('pendings.preload'),
                    icon: {
                        color: 'accent',
                        icon: 'archive'
                    },
                    method: null,
                    permission: 'appointment.update|detail_appointment.update|n_pending.update'
                },
                {
                    name: this.$t('pendings.pickeo'),
                    icon: {
                        color: 'accent',
                        icon: 'qr_code_scanner'
                    },
                    method: null,
                    permission: 'appointment.update|detail_appointment.update|n_pending.update'
                },
                {
                    name: this.$t('pendings.edit'),
                    icon: {
                        color: 'accent',
                        icon: 'mode_edit'
                    },
                    link: '/edit-appointment/',
                    permission: 'appointment.update|detail_appointment.update|n_pending.update'
                },
                {
                    name: this.$t('processed.files'),
                    icon: {
                        color: 'accent',
                        icon: 'folder'
                    },
                    link: '/upload-files-national/',
                    permission: 'appointment.file|n_pending.file'
                },
            ],
            props: {
                search: '',
                items: [],
                meta: {
                    total: 0,
                    total_pages: 0,
                    per_page: 10,
                    page: 1
                },
                sort_by: []
            },
            debounceTimer: null,
            pagination: {page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [], groupBy: [], groupDesc: [], multiSort: false, mustSort: false},
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
        }
    },
    mounted(){
        this.index();
        if(this.m_type == "income") this.$store.state.module = "headers.i_pendings_income";
        else if(this.m_type == "outcome") this.$store.state.module = "headers.i_pendings_outcome";    
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async index(){
            try{
                this.props.items = [];

                const res = await appointmentIndexUseCase('Pendiente', '0', this.m_type, this.props.meta.page, this.props.meta.per_page, this.props.search, null, this.props.sort_by, HttpAppointmentRepository);
                this.props.items = res.data;
                this.props.meta = res.meta;
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        to_create_national() {
            this.$router.push('/create-appointment/international/' + this.m_type);
        },
        to_upload_multiple() {
            this.$router.push('/upload-multiple-appointments');
        },
        to_massive_annex_24() {
            this.$router.push('/massive_annex_24')
        },
        async onOptionsChange(options) {
            this.props.meta.page = options.page;
            this.props.meta.per_page = options.itemsPerPage;
            
            if(options.sortBy.length > 0){
                this.props.meta.page = 1;
                this.props.sort_by = [{field: options.sortBy[0], direction: options.sortDesc[0] ? 'desc' : 'asc'}];
            } 
            else if(options.sortBy.length != this.props.sort_by.length) {
                this.props.meta.page = 1;
                this.props.sort_by = [];
            } 
            
            this.index();
        },
    },
    watch: {
        '$route.params.m_type': function() {
            location.reload();
        }
    }
}
</script>

<style lang="css">

</style>